import styled from 'styled-components'


export const SC_TransactionsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
